import {env} from 'common/env';
import {useEffect, useState} from 'react';

interface Props {
    crid?: number
}

const PreviewNative = (props: Props) => {

    const [preview, setPreview] = useState<any>()

    useEffect(() => {
        fetch(env.creativePreview + '?id=' + props.crid)
            .then(response => response.text())
            .then(body => setPreview(body))
            .catch(() => {
                console.debug('Fail to fetch creative for preview')
            })
    }, [])

    return (
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            {preview != null ? (
                <iframe
                    srcDoc={preview}
                    sandbox="allow-popups allow-popups-to-escape-sandbox"
                    style={{width: '100%', maxWidth: 1280, height: 640, border: 0}}
                />
            ) : null}
        </div>
    )
}

export default PreviewNative
